const SHELL_SESSION_KEY = 'theta.shell';
const SHELL_REDIRECT_DONE_KEY = 'theta.shellRedirectDone';
const SHELL_NAME_PATTERN = /^[A-Za-z0-9._-]{1,64}$/;

const safeSession = {
    get(key: string): string | null {
        try {
            return typeof window === 'undefined'
                ? null
                : window.sessionStorage.getItem(key);
        } catch {
            return null;
        }
    },
    set(key: string, value: string): void {
        try {
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(key, value);
            }
        } catch {
            // ignore
        }
    }
};

const safeLocal = {
    get(key: string): string | null {
        try {
            return typeof window === 'undefined'
                ? null
                : window.localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    set(key: string, value: string): void {
        try {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, value);
            }
        } catch {
            // ignore
        }
    }
};

export const captureShellFromUrl = (): void => {
    if (typeof window === 'undefined') {
        return;
    }
    const fromUrl = new URLSearchParams(window.location.search).get('shell');
    if (fromUrl && SHELL_NAME_PATTERN.test(fromUrl)) {
        safeSession.set(SHELL_SESSION_KEY, fromUrl);
    }
};

export const getShellName = (): string | null =>
    safeSession.get(SHELL_SESSION_KEY);

const normaliseUserId = (userId: string): string => userId.trim().toLowerCase();

export const getLastAssistantKey = (
    userId: string,
    shellName: string
): string => `user:${normaliseUserId(userId)}:shell:${shellName}:lastAssistant`;

export const rememberLastAssistant = (
    userId: string,
    shellName: string,
    assistantId: string
): void => {
    if (!userId || !shellName || !assistantId) {
        return;
    }
    safeLocal.set(getLastAssistantKey(userId, shellName), assistantId);
};

export const readLastAssistant = (
    userId: string,
    shellName: string
): string | null => {
    if (!userId || !shellName) {
        return null;
    }
    return safeLocal.get(getLastAssistantKey(userId, shellName));
};

export const hasShellRedirectFired = (): boolean =>
    safeSession.get(SHELL_REDIRECT_DONE_KEY) === '1';

export const markShellRedirectFired = (): void => {
    safeSession.set(SHELL_REDIRECT_DONE_KEY, '1');
};
